import { render, staticRenderFns } from "./CustomerDash.vue?vue&type=template&id=3cdae275"
import script from "./CustomerDash.vue?vue&type=script&lang=js"
export * from "./CustomerDash.vue?vue&type=script&lang=js"
import style0 from "./CustomerDash.vue?vue&type=style&index=0&id=3cdae275&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports